import { namespaces } from '@common'

export const namespace = namespaces.card.value
export const schema = 'cardGroupSchema'
export const backendDocType = 'CardGroup'
export const docPrivilege = 'card.cg'
